import React from 'react';

export default function SafetyRail({ className }) {
    return (
        <svg className={`${className}  w-8 h-8`}  fill="#e20303"  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4h20v2H2V4zm0 6h20v2H2v-2zm0 6h20v2H2v-2zm0 6h20v2H2v-2z"/>
            <path d="M5 4v18M12 4v18M19 4v18"/>
        </svg>
    );
}